<template>
  <v-app>
    <v-toolbar
      color="blue"
      dark
      fixed
      app
      clipped-right
      app>
      <v-toolbar-title class="text-truncate">{{lead.campaignName}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon :href="`/leads/${lead.id}`">
        <v-icon>launch</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <v-container>
        <v-alert
          v-model="alert"
          dismissible
          :color="oldInMins < 60 ? 'info' : 'error'"
          outline
          class="mb-4"
        >
          <div>ACT FAST: Sales Conversions are up to 380% within the 1st Minute. Drop below 80% after 5 Minutes.</div>
        </v-alert>
        <div v-if="oldInMins > 60" class="subheading">
          <v-icon>schedule</v-icon> {{lead.created | moment("lll")}}
        </div>
        <div v-else class="title text-info">
          <v-icon color="info">timer</v-icon> {{timer | moment("mm:ss") }}
        </div>
        <v-card v-if="questions" class="mt-4">
          <v-toolbar flat>
            <v-btn icon>
              <v-icon>question_answer</v-icon>
            </v-btn>
            <v-toolbar-title class="text-truncate">
              #{{lead.id}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="phone" color="success" round depressed :href="'tel:'+phone"><v-icon>phone</v-icon></v-btn>
          </v-toolbar>
          <v-data-table
            :items="questions"
            hide-actions
            hide-headers
            loading
          >
            <template v-slot:items="props">
              <td class="hidden-sm-and-down">{{ props.item.question }}</td>
              <td class="">
                <div class="hidden-md-and-up">
                  {{ props.item.question }}
                </div>
                <div class="font-weight-medium">
                  <span v-if="props.item.type === 'Date'">
                  {{ props.item.answer | date }}
                </span>
                  <span v-else>
                  {{ props.item.answer.join(', ') }}
                </span>
                </div>
              </td>
            </template>
          </v-data-table>
        </v-card>
        <v-card v-if="location" class="mt-4">
          <v-toolbar flat>
            <v-btn icon>
              <v-icon>my_location</v-icon>
            </v-btn>
            <v-toolbar-title class="text-truncate">{{location.city}}, {{location.region_code}}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <map-component
            :lat="location.latitude"
            :lng="location.longitude"
            :zoom="12"
            marker
          />
        </v-card>
        <v-card v-if="device" class="mt-4">
          <v-toolbar flat>
            <v-btn icon>
              <v-icon>devices</v-icon>
            </v-btn>
            <v-toolbar-title class="text-truncate">Device</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-data-table
            :items="device"
            hide-actions
            hide-headers
            loading
          >
            <template v-slot:items="props">
              <td class="">{{ props.item.key }}</td>
              <td class="text-truncate font-weight-medium">
                {{ props.item.value }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Spinner from '@/components/Spinner';
import axios from 'axios';
import moment from 'moment';
import MapComponent from '@/components/Map';

export default {
  name: 'LeadsDetails',
  components: {
    MapComponent,
    Spinner
  },
  data() {
    return {
      showSpinner: false,
      token: this.$route.params.token,
      lead: {},
      timer: "",
      oldInMins: 0,
      alert: true,
      phone: null,
      headers: [
        {
          text: 'Question',
          align: 'left',
          sortable: false,
          value: 'question'
        },
        {
          text: 'Answer',
          align: 'left',
          sortable: false,
          value: 'answer'
        },
      ],
    };
  },
  computed: {
    questions() {
      if (this.lead && this.lead.questions) {
        const questions = this.lead.questions;
        if (this.lead.data.context.prompt) {
          questions.unshift({
            question: this.lead.data.context.prompt,
            answer: [this.lead.input]
          })
        }

        return questions;
      }
      return null;
    },
    location() {
      return (this.lead && this.lead.data && this.lead.data.visitor) ? this.lead.data.visitor : null;
    },
    device() {
      if (this.lead && this.lead.data && this.lead.data.navigator) {
        const {deviceType, screenHeight, screenWidth, userAgent} = this.lead.data.navigator;
        return [
          {
            key: "type",
            value: deviceType
          },
          {
            key: "screen",
            value: `${screenWidth} x ${screenHeight}`
          },
          {
            key: "browser",
            value: userAgent
          },

        ];
      }
      return null;
    },
  },
  mounted() {
    this.fetchLead();
  },
  methods: {
    fetchLead() {
      this.showSpinner = true;
      const url = `${process.env.API_HOST}/lead/${this.token}`;
      return axios.get(url)
        .then(response => {
          this.lead = response.data.lead;
        })
        .finally(() => {
          this.showSpinner = false;
          this.findPhone();
          this.startTimer();
        });
    },
    startTimer: function () {
      const interval = setInterval(() => {
        const diff = moment().diff(this.lead.created);
        this.timer = moment.utc(diff);
        this.oldInMins = diff / 60000;
        if (this.oldInMins >= 60) {
          clearInterval(interval);
        }
      }, 1000);
    },
    findPhone: function () {
      this.lead.questions.forEach((q) => {
        const {answer, type} = q;
        if (type === "Phone") {
          this.phone = answer[0];
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  .v-toolbar__title {
    font-size: 18px;
    font-weight: 400;
  }
  .v-toolbar__content {
    height: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Leads/LeadMobile.vue